import { Dialog, DialogContent } from '@/components/ui/dialog';
import { CancellationForm } from '@/lib/layout/forms/cancel';
import type { Message } from '@/lib/layout/Header/components/StandardMessage';

import type { Policy } from '@/lib/heyapi/types.gen';

export const CancelPolicyDialog = ({
  isOpen,
  onOpenChange,
  policy,
  setMessage,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  policy: Policy | undefined;
  setMessage: (message: Message | undefined) => void;
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <CancellationForm
          policy={policy}
          setMessage={setMessage}
          onOpenChange={onOpenChange}
        />
      </DialogContent>
    </Dialog>
  );
};
